import { useSearchParams, useNavigate } from "react-router-dom";

export function SuccessPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const orderId = searchParams.get("orderId");

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 px-4">
      <div className="bg-white shadow-lg rounded-xl p-8 max-w-md w-full text-center">
        {/* 성공 아이콘 */}
        <div className="flex justify-center mb-4">
          <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center text-white text-3xl font-bold">
            ✓
          </div>
        </div>

        <h1 className="text-2xl font-bold text-gray-800 mb-2">
          🎉 결제가 성공적으로 완료되었습니다.
        </h1>

        {orderId && (
          <p className="text-gray-600 mb-6">
            주문 번호: <span className="font-semibold">{orderId}</span>
          </p>
        )}

        <p className="text-gray-500 mb-6">
          결제 내역은 마이페이지에서 확인하실 수 있습니다.
        </p>

        <button
          onClick={() => navigate("/spaces")}
          className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-lg shadow transition-colors"
        >
          홈으로 이동
        </button>
      </div>
    </div>
  );
}
